import script from "./MitiPortfolio.vue?vue&type=script&setup=true&lang=js"
export * from "./MitiPortfolio.vue?vue&type=script&setup=true&lang=js"

import "./MitiPortfolio.vue?vue&type=style&index=0&id=20c36861&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20c36861"]])

export default __exports__